import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserOutlined, LeftOutlined } from '@ant-design/icons';
import api from '../api';

export default function MyInfo() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user') || '{}');
    } catch {
      return {};
    }
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get('/auth/me')
      .then((data) => {
        if (cancelled || !data) return;
        setProfile(data);
        try {
          const prev = JSON.parse(localStorage.getItem('user') || '{}');
          localStorage.setItem('user', JSON.stringify({ ...prev, ...data }));
        } catch {
          localStorage.setItem('user', JSON.stringify(data));
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const row = (label, value) => (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '14px 0', borderBottom: '1px solid #f5f5f5', fontSize: 15,
    }}>
      <span style={{ color: '#999' }}>{label}</span>
      <span style={{ color: '#333', fontWeight: 500, textAlign: 'right', maxWidth: '62%', wordBreak: 'break-all' }}>
        {value ?? '-'}
      </span>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', maxWidth: 750, margin: '0 auto', paddingBottom: 24 }}>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '12px 16px', background: '#fff', borderBottom: '1px solid #f0f0f0',
        position: 'sticky', top: 0, zIndex: 10,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', minWidth: 0, flex: 1 }}>
          <LeftOutlined onClick={() => navigate(-1)} style={{ fontSize: 18, marginRight: 12, flexShrink: 0 }} />
          <span style={{ fontSize: 17, fontWeight: 600 }}>我的信息</span>
        </div>
        <button
          type="button"
          onClick={() => navigate('/change-password')}
          style={{
            flexShrink: 0,
            padding: '6px 4px',
            fontSize: 15,
            fontWeight: 600,
            color: '#1677ff',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          修改密码
        </button>
      </div>

      <div style={{ margin: 16, background: '#fff', borderRadius: 12, padding: '8px 20px 20px' }}>
        <div style={{ textAlign: 'center', padding: '16px 0 8px' }}>
          <div style={{
            width: 72, height: 72, borderRadius: 36, background: '#E8F0FE',
            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px',
          }}>
            <UserOutlined style={{ fontSize: 36, color: '#1677FF' }} />
          </div>
        </div>
        {row('姓名', profile.username)}
        {row('工号', profile.work_no)}
        {row('手机号', profile.phone)}
        {row('登录密码', '••••••••')}
        <div style={{ fontSize: 12, color: '#999', marginTop: 8, lineHeight: 1.5 }}>
          系统仅保存加密后的密码，无法查看明文。如需更换请点击右上角「修改密码」。
        </div>
      </div>
    </div>
  );
}
